<link href="https://fonts.cdnfonts.com/css/gotham" rel="stylesheet">

<h2 mat-dialog-title>
    Select Category
    <button class="close-button" (click)="onCancel()" disableRipple>
        <span class="material-symbols-outlined">
        close
        </span>
    </button>
</h2>
<mat-dialog-content class="mat-typography select-categories-dialog">
    <div class="audit-details">
        <app-project-detail
            [selectedProjectStatusId]="selectedProjectStatusId"
            [auditId]="auditId"
            [isFromAudit]="true"
            class="mainclass"
        ></app-project-detail>
    </div>
    <div class="select-categories-container">
        <div class="categories-header">
            <h3 class="font-weight-bold">Categories</h3>
        </div>
        <div class="categories-wrapper">
            <div class="d-flex justify-content-between" style="margin: 5px 0;">
                <div *ngIf="showAuditorSelection" class="auditor-container">
                    <span class="labelName">Auditor Name <sup class="requiredStar">*</sup>: </span>
                    <mat-form-field class="full-width" appearance="outline">
                        <input
                            [(ngModel)]="auditorName"
                            type="text"
                            matInput
                            placeholder="Select Auditor Name"
                            (input)="getFilteredValues($event.target.value)"
                            (focus)="getFilteredValues('')"
                            [matAutocomplete]="autoAuditor"
                            style="top: -6px; position: relative;"
                        />
                        <mat-autocomplete autoActiveFirstOption #autoAuditor="matAutocomplete">
                            <mat-option
                                *ngFor="let auditor of filteredSubAuditors"
                                [value]="auditor.userName"
                            >
                                {{ auditor.userName }} ({{ auditor.userId }})
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </div>
                <button
                    class="btn btn-primary add-category"
                    (click)="addCombo()"
                >+ Add Category</button>
            </div>

            <table *ngIf="dropdownCombos.length" class="categories-table">
                <thead>
                    <tr>
                        <th>Category Name</th>
                        <th>Sub Auditor</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let combo of dropdownCombos; let i = index">
                        <td>
                            <mat-form-field class="table-dropdown">
                                <mat-select
                                    class="category-dropdown"
                                    [(ngModel)]="combo.categoryId"
                                    placeholder="Select Category"
                                    (selectionChange)="validateCategory(i)"
                                >
                                    <mat-option
                                        *ngFor="let category of getFilteredCategories(i)"
                                        [value]="category.id"
                                    >{{ category.description }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field class="table-dropdown">
                                <input
                                    [(ngModel)]="combo.subAuditiorName"
                                    type="text"
                                    matInput
                                    placeholder="Select Sub-Auditor Name"
                                    (input)="getFilteredValues($event.target.value)"
                                    (focus)="getFilteredValues('')"
                                    [matAutocomplete]="autoAuditor"
                                />
                                <mat-autocomplete
                                    autoActiveFirstOption
                                    #autoAuditor="matAutocomplete"
                                    (optionSelected)="loadSubAuditors($event.option.value)"
                                >
                                    <mat-option
                                        *ngFor="let auditor of filteredSubAuditors"
                                        [value]="auditor.userName"
                                    >
                                        {{ auditor.userName }} ({{ auditor.userId }})
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </td>
                        <td>
                            <button
                                class="close material-symbols-outlined"
                                (click)="removeCombo(i)"
                            >close</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="custom-dialog-actions">
    <button
        class="btn btn-outline btn-spacing"
        style="border: 2px solid #1976D2;"
    >Save</button>
    <button
        class="btn btn-primary"
        style="background: #1976D2; color: white;"
        (click)="submit(dropdownCombos, true)"
    >Submit</button>
</mat-dialog-actions>
